import ObjUtil from "../utils/obj";

class Zone{
  static generateOverlayPayload(content, resolvedLocale){
    var tmpZone = new Flybits.Zone();
    tmpZone.id = ObjUtil.guid(2);
    tmpZone.name = 'Overlay';
    tmpZone.referenceID = 'overlay';
    
    var tmpModule = new Flybits.Module();
    tmpModule.id = ObjUtil.guid(2);
    tmpModule.layout = 'overlay';
    tmpModule.content = [content];
    tmpZone.modules = [tmpModule];

    var payload = tmpZone.toConciergeContainer(resolvedLocale);
    payload.containers[0].content[0].uiTemplate = content.detailsUI?.layoutHTML || '<!-- -->';
    payload.containers[0].content[0].style = content.detailsUI?.styleCSSURL || '';
    payload.containers[0].content[0].styleStr = content.detailsUI?.styleCSS || '';

    return payload;
  }

  static generateDetailsPayload(content, resolvedLocale){
    var tmpZone = new Flybits.Zone();
    tmpZone.id = ObjUtil.guid(2);
    tmpZone.name = 'Content Details';
    tmpZone.referenceID = 'details';
    
    var tmpModule = new Flybits.Module();
    tmpModule.id = ObjUtil.guid(2);
    tmpModule.layout = 'vertical';
    tmpModule.content = [content];
    tmpZone.modules = [tmpModule];

    var payload = tmpZone.toConciergeContainer(resolvedLocale);
    payload.containers[0].content[0].uiTemplate = content.detailsUI?.layoutHTML || '<!-- -->';
    payload.containers[0].content[0].style = content.detailsUI?.styleCSSURL || '';
    payload.containers[0].content[0].styleStr = content.detailsUI?.styleCSS || '';

    return payload;
  }
}

export default Zone;